import React, { useState } from 'react'
import styles from "./SupervisorReports.module.css"
import { Dropdown, InputField, SearchInput, TextComponent, Modal } from "../../../components";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../assets/images/actionicon.svg";
// import filtericon from "../../../../../assets/images/filter.svg";
import { SubmitButton } from "../../../components";
import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";


const SupervisorReports = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(true)
  const [password, setPassword] = useState("");
  const [filterModal, setFilterModal] = useState(false)
  const [status, setStatus] = useState({
    value: "Status",
    role: "Status",
    id: 1,
  });

  const columns = [
    {
      title: "Task ID",
      dataIndex: "TaskID",
      key: "TaskID",
    },
    {
      title: "Product Name",
      dataIndex: "ProductName",
      key: "ProductName",
    },
    {
      title: "Station",
      key: "Station",
      dataIndex: "Station",
    },
    {
      title: "Reportee",
      key: "Reportee",
      dataIndex: "Reportee",
    },
    {
      title: "Date/Time",
      key: "DateTime",
      dataIndex: "DateTime",
    },
    {
      title: "Status",
      key: "Status",
      dataIndex: "Status",
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },


  ];

  const data = [
    {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Pending",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    }, {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Reject",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    }, {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Approved",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    },
    {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Reject",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    },
    {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Approved",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    },
    {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Reject",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    },
    {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Approved",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    },
    {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Reject",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    },
    {
      TaskID: "#123",
      ProductName: "Ciabatta – 44 lbs",
      Station: "Mixing",
      Reportee: "Zara Olsen",
      DateTime: "08/11/2025 08:30 AM",
      Status: "Approved",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/supervisor/ReportsDetails")}
      />
    },
  ];

  const statusOpt = [
    { id: 1, value: "Status" },
    { id: 2, value: "Approved" },
    { id: 3, value: "Rejected" },
    { id: 4, value: "Advised" },
    { id: 4, value: "Pending" },

  ];



  return (
    <div>

      <div className={styles.mainCont}>
        {/* Heading Section with Right Controls */}
        <HeaderComponent
          heading={"Reports "}
          headingStyle={styles.headingStyle}
          onSearch={(e) => console.log(e.target.value)}
          onSubmit={() => navigate("/Warehouse/IngredientsMgmt/CreateNewGradient")}
          rightControlsStyle={styles.rightControlsStyle}
          showControlButtons={false}
          showFilterIcon={true}
          showBackIcon={false}
          showSearch={true}
          onClickFilter={() => setFilterModal(true)}
        />

        {/* Table Section */}
        <div className={styles.subCont}>
          <div className={styles.TableDiv}>
            <Table
              scroll={{ x: true }}
              columns={columns}
              dataSource={data}
              pagination={false}
              rowKey="No"
            />
          </div>
        </div>
      </div>


      {/* /////////confirm modal ///////////////////// */}

      <Modal
        open={isModal}
        onCancel={() => { setIsModal(false) }}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        className={styles.modalCont}
        title={"Enter Supervisor Password"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickCancelButton={() => setIsModal(false)}
      >
        <InputField
          placeholder={"12*******"}
          innerInput={{ width: "" }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>



      {/* //////////////////// Filters ////////////////////// */}

      <Modal
        open={filterModal}
        onCancel={() => {
          setFilterModal(false);
        }}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}

        twoButton
        okBtnTitle={"Apply Filters(1)"}
        cancelBtnTitle={"Reset All"}
        onClickCancelButton={() => setFilterModal(false)}
        onClickOkButton={() => {
          setFilterModal(false)
        }}

      >
        <Dropdown
          // label={"Stations"}
          // labelClass={styles.DropDownLabel}
          value={status}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={statusOpt}
          onChange={(e) => setStatus(e)}
        />

      </Modal>

    </div>
  )
}

export default SupervisorReports


